import styled, { css } from 'styled-components';

import { DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';

import {
  EmblaDots,
  EmblaButtonNext,
  EmblaButtonPrev,
  EmblaDot,
  CarouselWrapper,
  EmblaContainer,
} from '@/components/Carousel/styled';

export const StyledGrid = styled(Grid)`
  background: linear-gradient(180deg, #120c13 0%, #1c012e 100%);
`;

interface Props {
  slides: number;
  footer?: boolean;
}

export const StyledBox = styled('div')<Props>`
  ${({ footer, slides }) =>
    footer
      ? css`
          ${EmblaDots} {
            bottom: 34px;
            right: unset;
            left: 70px;

            ${media.smDown`
              bottom: 80px;
              right: 0;
              left: 0;
            `}
          }

          ${EmblaButtonPrev} {
            top: unset;
            bottom: 8px;
            left: 24px;
            fill: ${({ theme }) => theme.color.white};

            > svg {
              width: 16px;
              height: 16px;
            }

            ${media.smDown`
              bottom: 55px;
              left: 28px;
            `}
          }

          ${EmblaButtonNext} {
            top: unset;
            right: unset;
            left: ${70 + slides * 16}px;
            bottom: 8px;
            fill: ${({ theme }) => theme.color.white};

            > svg {
              width: 16px;
              height: 16px;
            }

            ${media.smDown`
              right: 28px;
              left: unset;
              bottom: 55px;
            `}
          }
        `
      : css`
          ${EmblaDots} {
            bottom: 34px;

            ${media.smDown`
              bottom: 25px;
            `}
          }

          ${EmblaButtonPrev} {
            top: unset;
            bottom: 8px;
            left: ${45 - 1.5 * slides}%;
            fill: ${({ theme }) => theme.color.white};

            > svg {
              width: 16px;
              height: 16px;
            }

            ${media.smDown`
              bottom: 0;
              left: 28px;
            `}
          }

          ${EmblaButtonNext} {
            top: unset;
            right: ${45 - 1.5 * slides}%;
            bottom: 8px;
            fill: ${({ theme }) => theme.color.white};

            > svg {
              width: 16px;
              height: 16px;
            }

            ${media.smDown`
              right: 28px;
              left: unset;
              bottom: 0;
            `}
          }
        `}

  ${EmblaDot} {
    margin-right: 0;
    margin-left: 0;

    &:after {
      width: 6px;
      height: 6px;
    }
  }

  ${CarouselWrapper} {
    height: 100%;
  }

  ${EmblaContainer} {
    height: 100%;
  }
`;
